export const environment = {
  name: 'qa',
  production: true,
  apiUrl: 'https://pet-more-stage.eu.aldryn.io/api/v1',
  googleApiToken: 'AIzaSyCCRmAReODgzMdpftfpXA42oSsofwuemRw',
  privacyPolicyUrl: 'https://pet-more-stage.eu.aldryn.io/privacy_policy/',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.petmore.app',
  appStoreUrl: 'https://apps.apple.com/br/app/petmore/id1540622218',
  website: 'https://www.petmore.com.br',
};
